// ABOUTME: Utility functions for generating consistent colors per child
// ABOUTME: Uses hash-based color generation with a nice predefined palette

// High contrast color palette for better accessibility and distinction
const COLOR_PALETTE = [
  '#2563EB', // Strong Blue
  '#DC2626', // Strong Red  
  '#059669', // Strong Green
  '#D97706', // Strong Orange
  '#7C3AED', // Strong Purple
  '#DB2777', // Strong Pink
  '#0891B2', // Strong Teal
  '#65A30D', // Strong Lime
  '#EA580C', // Strong Orange-Red
  '#4338CA', // Strong Indigo
  '#BE185D', // Strong Rose
  '#0D9488', // Strong Emerald
];

/**
 * Simple hash function to convert string to number
 */
function simpleHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

/**
 * Generate a consistent color for a child based on their ID
 * @param childId - The child's ID (number or string)
 * @returns Hex color string from the predefined palette
 */
export function getChildColor(childId: number | string): string {
  const id = childId.toString();
  const hash = simpleHash(id);
  const index = hash % COLOR_PALETTE.length;
  return COLOR_PALETTE[index];
}

/**
 * Get all colors used by a list of children
 * @param childIds - Array of child IDs
 * @returns Array of hex color strings in the same order as input
 */
export function getChildrenColors(childIds: (number | string)[]): string[] {
  return childIds.map(id => getChildColor(id));
}

/**
 * Get color mapping object for a list of children
 * @param childIds - Array of child IDs
 * @returns Object mapping child ID to color
 */
export function getChildColorMap(childIds: (number | string)[]): Record<string, string> {
  const colorMap: Record<string, string> = {};
  childIds.forEach(id => {
    colorMap[id.toString()] = getChildColor(id);
  });
  return colorMap;
}